import performReauth from './performReauth';
const reauthDebouncerThreshold = 500;
export default function createReauthHandler(reauth, apiContext) {
    let reauthPromise = Promise.resolve();
    let nextAllowedReauth = new Date().getTime();
    return apiHandler => {
        const reauthHandler = () => {
            nextAllowedReauth = new Date().getTime() + reauthDebouncerThreshold;
            return performReauth(reauth, apiContext);
        };
        if (new Date().getTime() < nextAllowedReauth) {
            const secondCallHandler = () => apiHandler(reauthHandler);
            reauthPromise = reauthPromise.then(secondCallHandler, secondCallHandler);
            return reauthPromise;
        }
        reauthPromise = reauthPromise.then(reauthHandler, reauthHandler);
        return reauthPromise;
    };
}
